import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    if (icon) {
      IconComponent = icon;
    } else if (name) {
      // Prevent double 'FiFi' prefixing which causes the warning triangle fallback
      const iconName = name.startsWith('Fi') ? name : `Fi${name}`;
      IconComponent = FiIcons[iconName];
    }
  } catch (e) {
    IconComponent = null;
  }
  
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;